import { Label } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOffer } from 'shared/selectors/offerData/selectOffer';

export const NoFeeLabelContainer: React.FC = () => {
  const { isNoFee } = useSelector(selectOffer);

  if (!isNoFee) {
    return null;
  }

  return (
    <Label background="overlay-control-default" color="theme-dark" data-testid="NoFeeLabel">
      Без комиссии
    </Label>
  );
};
